import React, { useState, useEffect } from "react";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import CustomToast from "../../components/Toast";
import { useDispatch } from "react-redux";
import * as actionUrl from "../../store/actions";
import { useSelector } from "react-redux";
import { useAuctionDetail } from "../../components/common/AunctioneerDeteailProvider";
import axiosMain from "../../http/axios/axios_main";
const auctionDetailId =
  window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[2]
    ? atob(
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[2]
    )
    : "";
const userId =
  window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[3]
    ? atob(
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[3]
    )
    : "";

function NotificationMsg() {
  const [notification, setNotification] = useState("");
  useEffect(() => {
    let socket = null;
    let stompClient = null;

    const socketHandler = () => {
      let url =
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_END_POINT_URL_DEV
          : process.env.REACT_APP_END_POINT_URL_PROD;

      // Connect to the server using SockJS
      socket = new SockJS(
        url +
        "/englishauction/connect?token=" +
        atob(sessionStorage.getItem("argument1"))
      );

      // Create a Stomp.js client over the WebSocket connection
      stompClient = Stomp.over(socket);

      const subscribeCall4 = () => {
        console.log("Subscribe Call 2");
        stompClient.subscribe(
          "/englishauction/broadcast/notification/" +
          userId +
          "/" +
          auctionDetailId,
          (message) => {
            if (message.body) {
              setNotification(message.body);
            }
          });
      }
      // Connect to the WebSocket server
      stompClient.connect({}, () => {
        console.log("Connected to WebSocket server");
        subscribeCall4();
      });

      // Handle disconnection and reconnection
      stompClient.debug = () => { }; // Suppress debug logs
      stompClient.onWebSocketClose = (event) => {
        console.log("WebSocket closed. Reconnecting...");
        socketHandler(); // Attempt to reconnect
      };
    };

    socketHandler();

    // Cleanup function
    return () => {
      if (stompClient !== null) {
        stompClient.disconnect();
      }
      if (socket !== null) {
        socket.close();
      }
    };
  }, []); // Only run once on component mount


  const [notifications, setNotifications] = useState([]);
  const [activeNotifications, setActiveNotifications] = useState([]);

  const userRoleCode = atob(localStorage.getItem("argument6"));

  const { auctionCenterId } = useAuctionDetail();

  const auctionCenterIdFromURI = window.location.pathname?.split("/")[4]
    ? atob(window.location.pathname.split("/")[4])
    : "";

  const auctionTypeFromURL = window.location.pathname?.split("/")[1]

  const userIdForAuctionPage = auctionTypeFromURL === "auctionPage"
    ? atob(localStorage.getItem("argument2"))
    : window.location.pathname?.split("/")[3]
      ? atob(window.location.pathname.split("/")[3])
      : "";

  const getAuctionMarquee = async (roleCode) => {
    const validRoles = ['BUYER', 'SELLER', 'AUCTIONEER'];
    if (!validRoles.includes(roleCode)) {
      console.warn(`Role ${roleCode} is not allowed to fetch marquee data.`);
      return [];
    }

    try {
      const response = await axiosMain.post(
        `admin/marquee/getAuctionMarquee/roleCode/${roleCode}`,
        {
          auctionCenterId: auctionCenterIdFromURI,
          ...(roleCode === 'BUYER'
            ? { buyerId: userIdForAuctionPage }
            : roleCode === 'SELLER'
              ? { sellerId: userIdForAuctionPage }
              : roleCode === 'AUCTIONEER'
                ? { auctioneerId: userIdForAuctionPage }
                : {})
        }
      );

      const data = response.data;
      console.log("data...", data)

      if (data && Array.isArray(data)) {
        console.log("data...inside if", data)
        return data;
      } else {
        console.error("No data received:");
        return [];
      }

    } catch (error) {
      console.error(`Error fetching marquee data:`, error);
      return [];
    }
  };

  useEffect(() => {
    let timer;

    const fetchAndMonitor = async () => {
      if (!['BUYER', 'SELLER', 'AUCTIONEER'].includes(userRoleCode)) return;

      const data = await getAuctionMarquee(userRoleCode);
      setNotifications(data);

      const updateActive = () => {
        const now = new Date();
        const filtered = data.filter((n) => {
          const start = new Date(n.startDate);
          const end = new Date(n.endDate);
          return start <= now && now <= end;
        });
        setActiveNotifications(filtered);
      };

      updateActive();
      timer = setInterval(updateActive, 1000);
    };

    fetchAndMonitor();

    return () => clearInterval(timer);
  }, []);


  return (
    <div>
      {/* Your other JSX */}
      <div class="status-bx-view">
        <div className="container-fluid">

          <div className="row">
            <div className="col-auto">
              <div class="status-bx">
                <span class="status-color-bx  custom_RED"></span>
                <span class="status-name"> Active Lots</span>
              </div>
            </div>

            <div className="col-auto">
              <div class="status-bx">
                <span class="status-color-bx custom_ORANGE"></span>
                <span class="status-name"> Indicates Division</span>
              </div>
            </div>

            <div className="col-auto">
              <div class="status-bx">
                <span class="status-color-bx custom_TURQUOISE"></span>
                <span class="status-name"> Met Reserve Price</span>
              </div>
            </div>

            <div className="col-auto">
              <div class="status-bx">
                <span class="status-color-bx custom_BLUE"></span>
                <span class="status-name"> Broadcast </span>
              </div>
            </div>

            <div className="col-auto">
              <div class="status-bx">
                <span class="status-color-bx custom_GREEN"></span>
                <span class="status-name"> Highest Bidder </span>
              </div>
            </div>

            <div className="col-auto">
              <div class="status-bx">
                <span class="status-color-bx custom_CORAL"></span>
                <span class="status-name"> Deal Indicator </span>
              </div>
            </div>


          </div>

          <div className="row">
            <div className="col-12">
              {notification ? (<><div id="notification">{notification}</div></>) : ''}
            </div>
          </div>

          {activeNotifications.length > 0 && (
            <div className="auction-marquee">
              <div className="notification">
                {activeNotifications.map((note, index) => (
                  <span key={index}>
                    {note.notificationText}
                    {index < activeNotifications.length - 1 && ' | '}
                  </span>
                ))}
              </div>
            </div>
          )}

        </div>
      </div>
      {/* Other parts of your JSX */}
    </div>
  );
}

export default NotificationMsg;
